module.exports = __webpack_public_path__ + "img/s4-1.f7e86518.jpg";